module.exports = {"ADM_INSPECT_ACCOUNTS_SEEING_AS":"Xem trang dưới vai trò","ADM_INSPECT_ACCOUNTS_BACK_TO_ADMIN":"Trở lại quyền quản trị"}